import { observer } from 'mobx-react-lite';
import { GraniteButton } from 'components/V2/Button/GraniteButton';
import { useCartContext } from 'screens/AccessExpressV3/CartProvider';
import { useAccessCheckoutContext } from 'screens/AccessExpressV3/context/AccessCheckoutProvider';
import { useModal } from 'hooks/useModal';
import { useCallback } from 'react';
import { AccessReviewOrderModal } from '../../ReviewOrderModal/AccessReviewOrderModal';
import { AccessReviewOrderForm } from 'api/accessexpressv3/schemas/AccessCheckoutSchemas';
import { useNavigate } from 'react-router-dom';

const CheckoutFooter = observer(() => {
  const cart = useCartContext();
  const {
    currentIndex,
    locations,
    isCheckoutFormValid,
    isCheckoutLoading,
    onSubmit,
    form,
  } = useAccessCheckoutContext();
  const { isOpen, open, close } = useModal();

  // const category = window.location.pathname.includes('checkout/access')
  //   ? 'Access'
  //   : 'Mobility';

  const disablePlaceOrder =
    currentIndex !== locations.length - 1 && locations.length !== 0;

  const handleConfirmation = ({
    order_name,
    invoiceId,
  }: AccessReviewOrderForm & { invoiceId?: string }) => {
    onSubmit({ ...form.getValues(), order_name, invoiceId });
  };

  const handleClose = useCallback(() => {
    close();
    cart.open();
  }, [cart, close]);

  const isAccessCheckoutPage =
    window.location.pathname.endsWith('checkout/access');

  const handlePlaceOrderClick = async () => {
    const isValid = await isCheckoutFormValid();
    if (!isValid) {
      return;
    }
    cart.close();
    open();
  };

  const navigate = useNavigate();

  const backToGrid = () => {
    cart.close();
    navigate(
      isAccessCheckoutPage
        ? './order-services/access'
        : './order-services/mobility?type=SMART%2520PHONE',
    );
  };

  const submitButtonProps =
    // isAccessCheckoutPage ?
    {
      form: 'access-checkout-form',
      type: 'button' as const,
      onClick: handlePlaceOrderClick,
    };
  // : {
  //     type: 'submit' as const,
  //     form: 'checkout-form',
  //   };

  return (
    <div className="flex flex-col gap-4">
      <GraniteButton
        variant="tertiary"
        disabled={disablePlaceOrder}
        {...submitButtonProps}
      >
        Place order
      </GraniteButton>
      <GraniteButton variant="secondary" onClick={backToGrid}>
        Cancel
      </GraniteButton>

      <AccessReviewOrderModal
        onConfirmation={handleConfirmation}
        isOpen={isOpen}
        close={handleClose}
        isCheckoutLoading={isCheckoutLoading}
      />
    </div>
  );
});

export default CheckoutFooter;
